import IconCloudSpace from "@/components/icons/IconCloudSpace.vue";
import IconTools from "@/components/icons/IconTools.vue";
import IconStatistic from "@/components/icons/IconStatistic.vue";
import IconHistory from "@/components/icons/IconHistory.vue";
import IconFile from "@/components/icons/IconFile.vue";
// import IconUpload from "@/components/icons/IconUpload.vue";
import IconPersonal from "@/components/icons/IconPersonal.vue";
import IconResource from "@/components/icons/IconResource.vue";
import IconMoney from "@/components/icons/IconMoney.vue";
import IconAd from "@/components/icons/IconAd.vue";
import IconDelete from "@/components/icons/IconDelete.vue";
import { defineAsyncComponent } from "vue";

// 修改占位组件的导入方式
const PlaceholderView = defineAsyncComponent(() =>
  import("./cloudspace/browsehistory/BrowseHistoryView.vue")
);

export const menuConfig = {
  cloudspace: {
    title: "云空间",
    icon: IconCloudSpace,
    items: [
      {
        key: "files",
        title: "所有文件",
        icon: IconFile,
        disabled: false,
        component: defineAsyncComponent(() =>
          import("./cloudspace/files/FilesView.vue")
        ),
      },

      // {
      //   key: "upload-history",
      //   title: "上传历史",
      //   icon: IconUpload,
      //   component: PlaceholderView,
      // },
      {
        key: "deleted-files",
        title: "已删除文件",
        icon: IconDelete,
        disabled: false,
        component: defineAsyncComponent(() =>
          import("./cloudspace/files/FilesView.vue")
        ),
      },

      { type: "divider" },

      {
        key: "personal",
        title: "个人主页",
        icon: IconPersonal,
        disabled: true,
        component: PlaceholderView,
      },
      {
        key: "browse-history",
        title: "浏览历史",
        icon: IconHistory,
        disabled: true,
        component: defineAsyncComponent(() =>
          import("./cloudspace/browsehistory/BrowseHistoryView.vue")
        ),
      },
      {
        key: "resource",
        title: "资源包",
        icon: IconResource,
        disabled: true,
        component: PlaceholderView,
      },
      {
        key: "money",
        title: "文件收款",
        icon: IconMoney,
        disabled: true,
        component: PlaceholderView,
      },
      {
        key: "ad",
        title: "广告分成",
        icon: IconAd,
        disabled: true,
        component: PlaceholderView,
      },
    ],
  },
  tools: {
    title: "工具",
    icon: IconTools,
    disabled: true,
    items: [
      {
        key: "compress",
        title: "文件压缩",
        icon: IconFile,
        disabled: true,
        component: PlaceholderView,
      },
      {
        key: "convert",
        title: "格式转换",
        icon: IconHistory,
        disabled: true,
        component: PlaceholderView,
      },
    ],
  },
  statistic: {
    title: "统计",
    icon: IconStatistic,
    disabled: true,
    items: [
      {
        key: "overview",
        title: "数据概览",
        icon: IconStatistic,
        disabled: true,
        component: PlaceholderView,
      },
      {
        key: "detail",
        title: "详细数据",
        icon: IconFile,
        disabled: true,
        component: PlaceholderView,
      },
    ],
  },
};
